const formatter = new Intl.NumberFormat('it-IT', {minimumFractionDigits: 1, maximumFractionDigits: 1});

export const formatValue = (value: number | null, suffix = '') => (value === null ? 'non calcolabile' : `${formatter.format(value)}${suffix}`);
